import { useState, useEffect } from 'react';
import { apiClient } from '../utils/api';

export interface Child {
  id: string;
  username: string;
  display_name: string;
  profile_image?: string;
  birthday?: string;
  age?: number;
}

export const useChildren = () => {
  const [children, setChildren] = useState<Child[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadChildren();
  }, []);

  const loadChildren = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/children');
      setChildren(response.data);
      setError(null);
    } catch (err: any) {
      console.error('Failed to load children:', err);
      setError(err.message || 'Failed to load children');
      setChildren([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    children,
    loading,
    error,
    refetch: loadChildren
  };
};

export const useCustodyEligibleChildren = () => {
  const [children, setChildren] = useState<Child[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadChildren();
  }, []);

  const loadChildren = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/children/custody-eligible');
      // Phoenix returns { children, count }; apiClient.get already unwraps data.
      const list = Array.isArray(response) ? response : response?.children ?? response?.data;
      setChildren(Array.isArray(list) ? list : []);
      setError(null);
    } catch (err: any) {
      console.error('Failed to load custody-eligible children:', err);
      setError(err.message || 'Failed to load children');
      setChildren([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    children,
    loading,
    error,
    refetch: loadChildren
  };
};